module.exports = __webpack_public_path__ + "static/img/img-2.1c55a38b.png";